module.exports = __webpack_public_path__ + "hinted-Montserrat-SemiBoldItalic.06f77929a0b27ab3b2e1.woff";


//////////////////
// WEBPACK FOOTER
// C:/progetti java/ispra-infoaria/ispra-infoaria/ispra-infoaria-wui/infoaria-wui-client/src/assets/custom-styles/fonts/hinted-Montserrat-SemiBoldItalic.woff
// module id = ../../../../../src/assets/custom-styles/fonts/hinted-Montserrat-SemiBoldItalic.woff
// module chunks = 1